import { api } from '@/services/apiClient';

/**
 * Thin typed wrapper around GET /api/models (backend/src/routes/models.ts)
 * — additive, optional live-mode data source for the AI Models page
 * (src/modules/aimodels). Demo mode keeps using config/models.config.ts's
 * MODEL_ROUTING as today; live mode may call this instead once wired, and
 * must fall back to the local config on failure. `status` is relayed
 * exactly as the backend reports it — never upgraded to "connected"
 * client-side.
 */
export interface BackendModelEntry {
  provider: 'anthropic' | 'openai';
  modelId: string;
  displayName: string;
  purpose: string | null;
  status: 'not_configured' | 'available' | 'unavailable' | 'error';
}

export async function fetchBackendModels(): Promise<BackendModelEntry[]> {
  const res = await api.get<{ data: BackendModelEntry[] }>('/api/models');
  return res.data;
}
